<template>
	<div class="layout layout--flush layout--rev pt portable-pt-" v-if="showingForm" id="layoutPointer">
		<div v-if="isLoading" class="layout__item u-1/1 u-text-align--center c-loader" style>
			<svg width="135" height="140" viewBox="0 0 135 140" xmlns="http://www.w3.org/2000/svg" fill="#eee" v-bind:class="'loading-image'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><rect y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.5s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"/><animate attributeName="y" begin="0.5s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"/></rect><rect x="30" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.25s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"/><animate attributeName="y" begin="0.25s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"/></rect><rect x="60" width="15" height="140" rx="6"><animate attributeName="height" begin="0s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"/><animate attributeName="y" begin="0s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"/></rect><rect x="90" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.25s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"/><animate attributeName="y" begin="0.25s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"/></rect><rect x="120" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.5s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"/><animate attributeName="y" begin="0.5s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"/></rect></svg>
		</div>

		<div
			class="layout__item u-1/3 u-1/1-palm u-1/2-lap desk-pl portable-pl-+ palm-mb lap-pl+"
			v-if="conditions && !isLoading"
		>
			<a
				@click="hideForm()"
				v-if="!hasSuccessfullySaved"
				class="c-link c-link--cta ml0 u-1/1 u-text-align--right mb epsilon u-font-weight--normal u-svg-stroke-fill"
			>
				<svg width="6" height="8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 8" v-bind:class="''" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="none" stroke="#3d3d3d" stroke-linecap="round" d="M5 8L1 4l4-4"/></svg>

				<span class="pl">Terug naar vergelijker</span>
			</a>
			<powered-by class="u-palm-visuallyhidden" :is-small="true"></powered-by>

			<div
				class="receipt-sidebar p palm-p- layout__item c-mobile-toggle"
				:class="{ 'c-mobile-toggle--toggled pb+': detailsToggled, 'u-text-align--center': isSaving }"
			>
				<template v-if="isSaving">
					<svg width="135" height="140" viewBox="0 0 135 140" xmlns="http://www.w3.org/2000/svg" fill="#eee" v-bind:class="'u-display--inline'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><rect y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.5s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"/><animate attributeName="y" begin="0.5s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"/></rect><rect x="30" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.25s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"/><animate attributeName="y" begin="0.25s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"/></rect><rect x="60" width="15" height="140" rx="6"><animate attributeName="height" begin="0s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"/><animate attributeName="y" begin="0s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"/></rect><rect x="90" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.25s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"/><animate attributeName="y" begin="0.25s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"/></rect><rect x="120" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.5s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"/><animate attributeName="y" begin="0.5s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"/></rect></svg>
				</template>
				<template v-else>
					<h1 @click="detailsToggled = !detailsToggled">Uw pakket</h1>
					<div class="receipt-sidebar__package u-box-shadow p mt c-mobile-toggle--contents">
						<h2 class="mb layout">
							<div class="layout__item u-1/3 pt--">
								<img
									width="85"
									:src="`${formRequest.SupplierLogoUrl}`"
									class="u-display--block u-float--left"
								/>
							</div>
							<div class="layout__item u-2/3 u-font-weight--bold">{{ conditions.PackageName }}</div>
						</h2>

						<hr />

						<div class="layout" v-for="(key, value) in formRequest.Tariffs" :key="key">
							<div class="layout__item u-1/2">{{ value }}</div>
							<div class="layout__item u-1/2">
								<b>{{ key }}</b>
							</div>
						</div>
						<div class="layout">
							<div class="layout__item u-1/1">
								<hr />
							</div>
							<div class="layout__item u-1/2">{{ Object.keys(formRequest.Receipt)[0] }}</div>
							<div class="layout__item u-1/2 u-text-align--right">
								<b>{{ Object.values(formRequest.Receipt)[0] }}</b>
							</div>
							<template v-if="formRequest.Discount && formRequest.Discount.Key">
								<div class="layout__item u-1/2 u-text-color-status--green">
									{{ formRequest.Discount.Key }}
								</div>
								<div class="layout__item u-1/2 u-text-align--right u-text-color-status--green">
									<b>- {{ formRequest.Discount.Value }}</b>
								</div>
							</template>
							<div class="layout__item u-1/1">
								<hr />
							</div>
							<div class="layout__item u-1/1 u-text-align--right receipt-sidebar__package--total">
								<h3>{{ formRequest.Receipt['Verwachte jaarkosten'] }}</h3>
								Verwachte jaarkosten
								{{ conditions.BtwLabelExplicitly }}
							</div>
							<div class="layout__item u-1/1 u-text-align--right">
								<span class="u-text-color-grey">{{ formRequest.GovernmentLevies }}</span>
							</div>
						</div>
					</div>
					<div
						class="receipt-sidebar__action p- u-box-shadow c-mobile-toggle--contents"
						v-if="formRequest.ActionText"
						v-html="formRequest.ActionText"
					></div>
				</template>
			</div>
			<usp-list :supplierName="formRequest.SupplierName" :uspList="formRequest.UniqueSellingPoints"></usp-list>
		</div>
		<powered-by
			class="u-default-visuallyhidden u-palm-display--block u-dir-ltr"
			:phone-only="true"
			:is-small="true"
		></powered-by>
		<template v-if="hasSuccessfullySaved">
			<div class="layout__item u-2/3 u-1/1-palm u-1/2-lap ph-">
				<form-steps :step="3"></form-steps>
				<h1>Gefeliciteerd!</h1>
				<p class="pt+ pb0">
					Uw aanmelding is gelukt! U ontvangt de bevestiging van uw inschrijving in uw mailbox
				</p>
				<a @click="hideForm()" class="c-button">Terug naar vergelijker</a>
			</div>
		</template>
		<div
			class="layout__item u-2/3 u-1/1-palm u-1/2-lap desk-pr portable-pr- c-register-form"
			v-if="!hasSuccessfullySaved && questions && !isLoading"
		>
			<form-steps :step="2"></form-steps>
			<div class="layout">
				<div
					class="layout__item"
					:class="{ 'u-2/3  u-1/1-palm': formRequest.Discount && formRequest.Discount.Key }"
				>
					<h2 class="mb mt-">Meld u nu aan bij {{ conditions.SupplierName }}</h2>
					<p>
						Meld u nu aan voor
						<b>{{ conditions.PackageName }}</b>
						. {{ conditions.SupplierName }} verzorgt uw volledige overstap. U komt geen moment zonder
						energie te zitten.
					</p>
				</div>

				<template v-if="formRequest.Discount && formRequest.Discount.Key">
					<div class="layout__item u-1/3 u-1/1-palm">
						<div class="c-form-discount mt" :class="{ 'c-form-discount--filled': discountCircleFilled }">
							<div class="c-form-discount--circle-wrap mb">
								<div class="c-form-discount--circle">
									<small>{{ formRequest.Discount.Key === 'Welkomstpremie' ? 'Eenmalig' : '' }}</small>
									<span>{{ formRequest.Discount.Value }}</span>
								</div>
							</div>
							<h4 class="zeta">{{ formRequest.Discount.Key }}</h4>
						</div>
					</div>
				</template>
				<div
					:key="q.Key + Math.random()"
					:data-key="q.Key"
					v-for="q in questions"
					:class="{
						hidden: !q.Value.IsVisible,
						'u-1/2 u-1/1-palm':
							q.Value.Key.indexOf('PostalCode') > -1 ||
							q.Value.Key.indexOf('LastName') > -1 ||
							q.Value.Key.indexOf('Phone') > -1 ||
							q.Value.Key.indexOf('DateOfBirth') > -1 ||
							q.Value.Key.indexOf('Street') > -1 ||
							q.Value.Key.indexOf('City') > -1,
						'u-1/4 u-1/1-palm':
							(q.Value.Key.indexOf('HouseNumber') > -1) | (q.Value.Key.indexOf('Initials') > -1) ||
							q.Value.Key.indexOf('Insertion') > -1,
					}"
					:ref="q.Key"
					class="u-1/1-portable layout__item mt- c-question-wrapper"
				>
					<text-input
						@updatedvalue="saveProgress"
						v-if="
							q.Value.Type === 'Text' ||
							q.Value.Type === 'Number' ||
							q.Value.Type === 'Email' ||
							q.Value.Type === 'Phone'
						"
						:question="q"
					/>
					<checkbox-input
						@updatedvalue="saveProgress"
						v-else-if="q.Value.Type === 'Checkbox'"
						:question="q"
					/>
					<radio-input v-else-if="q.Value.Type === 'Radio'" @updatedvalue="saveProgress" :question="q" />
					<date-input v-else-if="q.Value.Type === 'Date'" @updatedvalue="saveProgress" :question="q" />
					<label-input
						v-else-if="q.Value.Type === 'Label' || q.Value.Type === 'Warning' || q.Value.Type === 'Info'"
						:question="q"
					/>
					<p v-else>Niets gevonden voor {{ q }}</p>

					<template v-if="q.Value.Key === 'Kvk'">
						<small>Als u een Kvk nummer invoert, dan zoeken wij de bijbehorende gegevens</small>
						<ul class="o-list-base">
							<li
								v-for="(entry, $index) in KvkEntries"
								v-bind:key="$index"
								class="p- u-border u-cursor--pointer"
								@click="selectKvKEntry(entry)"
							>
								{{ entry.CompanyName }}
								<Br />
								<small>
									{{ entry.Street }} {{ entry.HouseNumber }} {{ entry.HouseNumberAddition }}
									{{ entry.City }}
								</small>
							</li>
						</ul>
					</template>

					<template v-if="q.Value.Key === 'Company'">
						<small>Als u een bedrijfsnaam invoert, dan zoeken wij de bijbehorende gegevens</small>
						<ul class="o-list-base">
							<li
								v-for="(entry, $index) in CompanyEntries"
								v-bind:key="$index"
								class="p- u-border u-cursor--pointer"
								@click="selectKvKEntry(entry)"
							>
								{{ entry.CompanyName }}
								<Br />
								<small>
									{{ entry.Street }} {{ entry.HouseNumber }} {{ entry.HouseNumberAddition }}
									{{ entry.City }}
								</small>
							</li>
						</ul>
					</template>
					<span class="error u-text-color-orange" v-if="errorList[q.Key] && showErrors">
						{{ errorList[q.Key] }}
					</span>
				</div>

				<div v-if="formError.hasError" class="u-text-color-status--red u-border p mb">
					<p>Er ging iets mis bij het opslaan van het formulier.</p>
					<small>{{ formError.errorText }}</small>
				</div>
				<div class="u-1/1 layout__item mt" v-if="questions && !isLoading">
					<div class="bg-brand p">
						<div v-if="clientId === 'veh'" class="layout__item u-1/1 pl0">
							Wanneer u zich aanmeldt, gaat u akkoord met de
							<a
								style="font-weight: bold"
								class="u-text-color-orange"
								target="_blank"
								rel="noopener noreferrer"
								href="https://www.eigenhuis.nl/docs/default-source/downloads/diensten/deelnemersvoorwaarden-energievergelijker_juni-2019.pdf?sfvrsn=879dd96_2"
								>deelnemersvoorwaarden</a
							>
							van Vereniging Eigen Huis en gaat u tevens akkoord met de
							<a @click="showModal = true" class="u-font-weight--bold u-cursor--pointer">voorwaarden</a>
							van {{ conditions.SupplierName }} en sluit u een overeenkomst met betalingsverplichting met
							{{ conditions.SupplierName }}.
						</div>

						<div class="u-3/4 u-1/1-portable layout__item pl0">
							&check; Uw gegevens worden via een beveiligde verbinding verstuurd
							<span v-if="targetGroup !== 'Business'">
								<br />&check; U hebt 14 kalenderdagen bedenktijd na ontvangst contract leverancier
							</span>
						</div>
						<div class="u-text-align--right u-1/4 u-1/1-portable palm-pl0 layout__item">
							<a
								@click="saveForm()"
								v-if="!hasSuccessfullySaved"
								:disabled="isSaving"
								class="c-button c-button--brand"
							>
								<template v-if="isSaving">
									<svg width="135" height="140" viewBox="0 0 135 140" xmlns="http://www.w3.org/2000/svg" fill="#eee" v-bind:svg-inline="''" v-bind:class="'u-single-em-height'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><rect y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.5s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"/><animate attributeName="y" begin="0.5s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"/></rect><rect x="30" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.25s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"/><animate attributeName="y" begin="0.25s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"/></rect><rect x="60" width="15" height="140" rx="6"><animate attributeName="height" begin="0s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"/><animate attributeName="y" begin="0s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"/></rect><rect x="90" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.25s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"/><animate attributeName="y" begin="0.25s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"/></rect><rect x="120" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.5s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"/><animate attributeName="y" begin="0.5s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"/></rect></svg>
								</template>
								<template v-else>Aanmelden</template>
							</a>
						</div>
					</div>

					<powered-by
						class="u-default-visuallyhidden u-palm-display--block u-dir--rtl"
						:is-small="true"
						:no-phone="true"
					></powered-by>
				</div>
			</div>

			<supplier-modal
				v-if="showModal"
				:show="showModal"
				@close="showModal = false"
				:modal-content="conditions"
			></supplier-modal>
		</div>
		<div
			class="layout__item ph u-1/1 c-default-transparent-container c-default-transparent-container--margin"
			v-if="formRequest"
		>
			<timeline :timelineItems="formRequest.TimelineItems"></timeline>
		</div>
	</div>
</template>

<script>
import Api from '@/services/api.energy';
import TextInput from '@/partials/form/TextInput';
import CheckboxInput from '@/partials/form/CheckboxInput';
import RadioInput from '@/partials/form/RadioInput';
import DateInput from '@/partials/form/DateInput';
import LabelInput from '@/partials/form/LabelInput';
import FormSteps from '@/partials/form/Steps';
import PoweredBy from '@/energy/partials/PoweredBy';
import SupplierModal from '@/partials/SupplierModal';
import UspList from '@/partials/UspList';
import Timeline from '@/partials/Timeline';
import { eventHub } from '@/services/eventhub';

export default {
	props: {
		targetGroup: {
			type: String,
			default: '',
		},
	},
	components: {
		TextInput,
		DateInput,
		CheckboxInput,
		RadioInput,
		SupplierModal,
		LabelInput,
		FormSteps,
		PoweredBy,
		UspList,
		Timeline,
	},
	data() {
		return {
			detailsToggled: false,
			modalContent: null,
			showModal: false,
			urlParams: '',
			isSaving: false,
			questions: null,
			isLoading: false,
			serialId: null,
			formRequest: null,
			conditions: null,
			showErrors: false,
			errorList: {},
			hasSuccessfullySaved: false,
			KvkEntries: [],
			CompanyEntries: [],
			formError: {
				hasError: false,
				errorText: '',
			},
			// eslint-disable-next-line
			clientId: APP_CLIENTID,
			// eslint-disable-next-line
			customSuccessRedirect: APP_CUSTOM_THANKS,
			// eslint-disable-next-line
			customSuccessRedirectBusiness: APP_CUSTOM_THANKS_BUSINESS,
			// eslint-disable-next-line
			discountCircleFilled: APP_DISCOUNTCIRCLEFILLED,
			// eslint-disable-next-line
			isWebComponent: APP_TYPE === 'webcomponent',
		};
	},
	async mounted() {
		eventHub.$on('show-form', async (data) => {
			this.formError.hasError = false;
			this.isLoading = true;
			if (data.RegistrationFormLink) {
				this.urlParams = data.RegistrationFormLink.Value.split('?')[1];
				this.serialId = data.SerialId;
			} else {
				this.urlParams = data.UrlParams;
				this.serialId = data.ProductId;
			}

			this.getData(data.SerialId, this.urlParams);
			let splittedParams = this.urlParams.split('&');
			let cleanedParams = '';
			for (var key in splittedParams) {
				var param = splittedParams[key];
				if (
					param.indexOf('pcnum') === -1 &&
					param.indexOf('pcalpha') === -1 &&
					param.indexOf('pchousenr') === -1 &&
					param.indexOf('pchousenrextension') === -1
				) {
					cleanedParams += param + '&';
				}
			}
			this.urlParams = cleanedParams;
			setTimeout(() => {
				try {
					window.scrollTo(0, 0);
				} catch {
					// Unable to scroll window
				}
				try {
					parent.scrollTo(0, 0);
				} catch {
					// Unable to scroll parent
				}

				let wrapper = document.getElementById('tgt-comparison');
				if (wrapper) {
					let buttonTopDistance = wrapper.getBoundingClientRect().top;
					if (buttonTopDistance < 0) {
						let yOffset = window.pageYOffset;
						let scrollToPos = yOffset + buttonTopDistance;
						window.scrollTo(0, scrollToPos);
					}
				}
			}, 1000);
		});
	},
	methods: {
		selectKvKEntry(entry) {
			let companyNameField = this.questions.find((q) => q.Key === 'Company');
			companyNameField.Value.UserValue = entry.CompanyName;

			let streetField = this.questions.find((q) => q.Key === 'DeliveryAddress.Street');
			streetField.Value.UserValue = entry.Street;

			let houseNumberField = this.questions.find((q) => q.Key === 'DeliveryAddress.HouseNumber');
			houseNumberField.Value.UserValue = entry.HouseNumber;

			let houseNumberAdditionField = this.questions.find((q) => q.Key === 'DeliveryAddress.HouseNumberAddition');
			houseNumberAdditionField.Value.UserValue = entry.HouseNumberAddition;

			let postalCodeField = this.questions.find((q) => q.Key === 'DeliveryAddress.PostalCode');
			postalCodeField.Value.UserValue = entry.PostalCode;

			let cityField = this.questions.find((q) => q.Key === 'DeliveryAddress.City');
			cityField.Value.UserValue = entry.City;

			let kvkField = this.questions.find((q) => q.Key === 'Kvk');
			kvkField.Value.UserValue = entry.KvkNumber;

			this.KvkEntries = [];
			this.CompanyEntries = [];
		},
		isBusiness() {
			return this.isBusiness;
		},
		hideForm() {
			this.questions = null;
			this.errorList = {};
			this.formRequest = null;
			this.conditions = null;
			this.hasSuccessfullySaved = false;
			eventHub.$emit('hide-form');
		},
		async getData(serialId, params = '') {
			let formData = await Api.getBaseForm(serialId, params);
			let questions = formData.FormRequest.Questions;
			questions.forEach((q) => {
				let predefinedValue = q.Value.Value;
				// Quirk, needs to be fixed in API
				if (predefinedValue === 'false') {
					predefinedValue = false;
				} else if (predefinedValue === 'true') {
					predefinedValue = true;
				}
				q.Value.UserValue = predefinedValue;

				let depedencySettings = this.hasDependentQuestions(q, questions);

				q.hasDependentQuestions = depedencySettings.hasDependentQuestions;

				q.showTooltip = false;
			});

			this.questions = questions;
			this.formRequest = formData.FormRequest;
			this.conditions = formData.Conditions;
			this.setVisibility();
			this.isLoading = false;
			return;
		},
		hasDependentQuestions(question, questions) {
			let key = question.Key;

			let hasDependentQuestions =
				questions.filter((q) => {
					if (!q.Value.DependsOn) {
						return false;
					}

					let isDependentOn =
						q.Value.DependsOn.filter((dO) => {
							let isDependent = Object.keys(dO).indexOf(key) > -1;

							if (isDependent) {
								if (!q.dependencies) {
									q.dependencies = [];
								}
								let field = Object.keys(dO)[0];
								let value = Object.values(dO)[0].Value;
								let range = Object.values(dO)[0].Range;
								q.dependencies.push({
									field: field,
									visibleOn: value,
									visibleOnRange: range,
								});
							}
							return isDependent;
						}).length > 0;
					return isDependentOn;
				}).length > 0;

			return {
				hasDependentQuestions: hasDependentQuestions,
			};
		},
		getFormData() {
			let formData = {};
			this.questions.forEach((q) => {
				if (q.Value.Type !== 'Label') {
					let newValue = q.Value.UserValue; // ? q.Value.UserValue : '';
					if (newValue === null || typeof newValue === 'undefined' || newValue === '') {
						return;
					}

					if (newValue === 'true') {
						newValue = true;
					}
					if (newValue === 'false') {
						newValue = false;
					}
					let parts = q.Key.split('.');
					if (parts.length > 1) {
						parts.forEach((part, index) => {
							if (index === parts.length - 1) {
								formData[parts[index - 1]][part] = newValue;
							} else {
								if (!formData[part]) {
									formData[part] = {};
								}
							}
						});
					} else {
						formData[q.Key] = newValue;
					}
				}
			});
			return formData;
		},
		async setVisibility() {
			this.questions
				.filter((q) => q.dependencies)
				.forEach((q) => {
					let isVisibleThroughDep = true;

					q.dependencies.forEach((dep) => {
						let fieldValue = this.getFieldValue(dep.field);

						if (typeof fieldValue === 'undefined' || fieldValue === null) {
							isVisibleThroughDep = false;
							return;
						}
						if (typeof dep.visibleOn !== 'undefined') {
							if (fieldValue !== dep.visibleOn) {
								isVisibleThroughDep = false;
							}
						}

						if (typeof dep.visibleOnRange !== 'undefined') {
							let isMoving = this.getFieldValue('StartDate.IsMoving');
							let fieldValueNonMoving = this.getFieldValue('StartDate.SpecificStartDate');

							isVisibleThroughDep = isMoving
								? this.dateIsInRange(fieldValue, dep.visibleOnRange)
								: this.dateIsInRange(fieldValueNonMoving, dep.visibleOnRange);
						}
					});

					q.Value.IsVisible = isVisibleThroughDep;
				});
			this.$forceUpdate();
		},
		dateIsInRange(date, range) {
			if (!date || date.length !== 10) {
				return false;
			}
			let dateRange = [...range.split(',')];
			let start = dateRange[0];
			let end = dateRange[1];
			let startComparison = this.getComparisonFromDateString(start);
			let endComparison = this.getComparisonFromDateString(end);
			let formDate = this.getComparisonFromDateString(date);

			return formDate >= startComparison && formDate <= endComparison;
		},
		getComparisonFromDateString(date) {
			return new Number(date.split('-').reverse().join(''));
		},
		getFieldValue(key) {
			if (this.questions.find((q) => q.Key === key)) {
				return this.questions.find((q) => q.Key === key).Value.UserValue;
			} else {
				console.info('no field for', key);
				return null;
			}
		},
		async saveProgress(settings = {}) {
			let formData = this.getFormData();

			formData.DoInsert = false;
			if (settings.question) {
				delete this.errorList[settings.question.Key];
				this.$forceUpdate();
			}
			if (settings.update) {
				this.postForm(formData);
			}
			this.setVisibility();
		},
		async saveForm() {
			let formData = this.getFormData();
			formData.DoInsert = true;
			await this.postForm(formData);
			this.showErrors = true;
		},
		async postForm(formData) {
			this.isSaving = true;
			this.formError.hasError = false;
			let response = null;

			if (formData.DoInsert) {
				this.track('Saving form trying', this.formRequest.SupplierName, this.formRequest.PackageName);
			}

			try {
				response = await Api.saveForm(formData, this.serialId, this.urlParams);
			} catch (e) {
				console.error('Error while saving', e);
			}
			this.isSaving = false;
			if (!response.response) {
				this.formRequest.ActionText = response.FormRequest.ActionText;
				this.formRequest.Receipt = response.FormRequest.Receipt;
				this.formRequest.Discount = response.FormRequest.Discount;
				if (response.IsValid) {
					if (formData.DoInsert) {
						this.errorList = {};
						this.track('Saving form success', this.formRequest.SupplierName, this.formRequest.PackageName);
						let url = '';
						if (
							this.targetGroup === 'Consumer' &&
							this.customSuccessRedirect &&
							this.customSuccessRedirect !== ''
						) {
							url = this.customSuccessRedirect;
						}
						if (
							this.targetGroup === 'Business' &&
							this.customSuccessRedirectBusiness &&
							this.customSuccessRedirectBusiness !== ''
						) {
							url = this.customSuccessRedirectBusiness;
						}
						if (url && url.length > 0) {
							url = url.replace('{0}', encodeURIComponent(this.formRequest.SupplierName));
							url = url.replace('{1}', encodeURIComponent(this.formRequest.PackageName));

							if (this.isWebComponent) {
								window.location.href = url;
							} else {
								window.open(url);
							}
						}
						this.hasSuccessfullySaved = true;
					}
				} else {
					this.questions.forEach((q) => {
						q.Value.IsVisible = false;
					});
					let firstError = null;
					response.FormRequest.Questions.forEach((q) => {
						if (formData.DoInsert) {
							if (q.Value.HasError) {
								this.errorList[q.Key] = q.Value.ErrorMessage;
								if (!firstError) {
									firstError = q.Key;
								}
							}
						}
						let shadowQ = this.questions.find((oQ) => {
							return oQ.Key === q.Key;
						});
						if (shadowQ) {
							let visibility = true;
							if (typeof q.Value.IsVisible !== 'undefined' || q.Value.IsVisible === false) {
								visibility = false;
							}
							shadowQ.Value.IsVisible = visibility;

							let predefinedValue = q.Value.Value;
							if (predefinedValue && predefinedValue !== '') {
								shadowQ.Value.UserValue = predefinedValue;
							}
						}
					});

					if (
						response.SearchResults &&
						response.SearchResults.Kvk &&
						response.SearchResults.Kvk.KvkEntries.length > 0
					) {
						this.KvkEntries = response.SearchResults.Kvk.KvkEntries;
					}
					if (
						response.SearchResults &&
						response.SearchResults.Company &&
						response.SearchResults.Company.KvkEntries.length > 0
					) {
						this.CompanyEntries = response.SearchResults.Company.KvkEntries;
					}
					if (formData.DoInsert) {
						let firstErrorElement = this.$refs[firstError];

						this.track(
							'Saving form failed',
							this.formRequest.SupplierName + ' ' + this.formRequest.PackageName,
							JSON.stringify(this.errorList)
						);

						if (firstErrorElement) {
							setTimeout(() => {
								firstErrorElement[0].scrollIntoView({ block: 'start' });
							}, 400);
						} else {
							console.error('Invalid response without erroring question');
						}
					}
				}
			} else {
				this.formError = {
					errorText: `${response.response.status}: ${response.message}`,
					hasError: true,
				};
			}
		},
	},
};
</script>

<style></style>
